export default __webpack_public_path__ + "static/media/rgs_big@2x.3eec05e4.jpg";